import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavbarService implements OnDestroy {

    destroy$ = new Subject<void>();
    showNavbar: boolean = true;

    bottomBorder: "VISIBLE" | "HIDDEN" = "VISIBLE";

    settingsVisible: boolean = false;
    submenuVisible: boolean = false;
    activeNavItem: string = '';

    constructor(
    ) { }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get classList() {
        let cls = [];
        switch (this.bottomBorder) {
            case "VISIBLE":
                cls.push('bottom-border-visible');
                break;
            case "HIDDEN":
                cls.push('bottom-border-hidden');
                break;
        }
        return cls;
    }
}
